import { isArray, isFunction } from 'lodash'

import { getIdOrNull, validateString } from '..'
import { Properties } from '../entities'

const { NAME, COLOR, INSTITUTION } = Properties

export const HOSPITAL_DEPARTMENT_VALIDATORS = [
  { key: NAME, validator: h => validateString(h[NAME], { notEmpty: true }) },
  { key: COLOR, validator: h => validateString(h[COLOR], { nullable: true }) }
]

const WITH_ID_PROPS = new Set([INSTITUTION])

export const getName = h => h.name ?? null
export const getColor = h => h.color ?? null

export const getManagersLabel = h => {
  let label = ''

  if (isArray(h.managers)) {
    label = h.managers.map(m => {
      if (m.firstname && m.lastname) {
        return `${m.firstname} ${m.lastname} - ${m.email}`
      } else {
        return m.email
      }
    }).join(', ')
  }

  return label
}

export class HospitalDepartment {
  constructor ({ id, institution = null, name = '', managers = [], color = '' } = {}) {
    this.id = id ?? -1
    this.institution = institution
    this.name = name
    this.managers = managers
    this.color = color
  }

  toRequestBody = () => {
    const body = {}

    Object.entries(this).forEach(([key, val]) => {
      if (!isFunction(val)) {
        if (WITH_ID_PROPS.has(key)) {
          body[key] = getIdOrNull(val)
        } else if (Array.isArray(val)) {
          body[key] = val.map(v => getIdOrNull(v))
        }
      }
    })

    return body
  }
}
